<app-page-breadcrumb pageTitle="Configuración de Correo"></app-page-breadcrumb>

<div class="space-y-6">

  <!-- Success message -->
  @if (successMessage) {
  <div class="p-4 bg-success-50 border border-success-200 rounded-lg dark:bg-success-500/10 dark:border-success-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-success-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-success-700 dark:text-success-400">{{ successMessage }}</p>
    </div>
  </div>
  }

  <!-- Error message -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-16">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando configuración...</span>
  </div>
  }

  <!-- ─── FORM VIEW ──────────────────────────────────────────────────────── -->
  @if (!loading && showForm) {
  <app-component-card
    [title]="config ? 'Editar Configuración de Correo' : 'Nueva Configuración de Correo'"
    desc="Complete los datos del proveedor de correo electrónico">

    <!-- Error inside form -->
    @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    <form (ngSubmit)="guardar()" #emailForm="ngForm" class="space-y-5">

      <!-- Tipo de proveedor -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de proveedor <span class="text-error-500">*</span>
        </label>
        <select
          name="providerType"
          [(ngModel)]="formProviderType"
          required
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed">
          @for (opt of providerOptions; track opt.value) {
          <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>

      <!-- Correo remitente -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Correo remitente <span class="text-error-500">*</span>
        </label>
        <input
          type="email"
          name="fromEmail"
          [(ngModel)]="formFromEmail"
          required
          placeholder="noreply@miempresa.com"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>

      <!-- Nombre remitente -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre del remitente
        </label>
        <input
          type="text"
          name="fromName"
          [(ngModel)]="formFromName"
          placeholder="Mi Empresa"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>

      <!-- ─── SMTP fields ─────────────────────────────────────────────────── -->
      @if (isSmtp) {
      <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-4">
        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Configuración SMTP</p>

        <!-- Servidor SMTP -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Servidor SMTP
          </label>
          <input
            type="text"
            name="smtpHost"
            [(ngModel)]="formSmtpHost"
            placeholder="smtp.gmail.com"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Puerto SMTP -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Puerto
          </label>
          <input
            type="number"
            name="smtpPort"
            [(ngModel)]="formSmtpPort"
            min="1"
            max="65535"
            placeholder="587"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Normalmente 587 (TLS) o 465 (SSL)</p>
        </div>

        <!-- Usuario SMTP -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Usuario SMTP
          </label>
          <input
            type="text"
            name="smtpUsername"
            [(ngModel)]="formSmtpUsername"
            placeholder="usuario@gmail.com"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Contraseña SMTP -->
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Contraseña SMTP
          </label>
          <input
            type="password"
            name="smtpPassword"
            [(ngModel)]="formSmtpPassword"
            placeholder="••••••••"
            autocomplete="new-password"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          @if (config) {
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Dejar vacío para mantener la contraseña actual</p>
          }
        </div>

        <!-- TLS / SSL checkboxes -->
        <div class="flex items-center gap-6">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="smtpUseTls"
              [(ngModel)]="formSmtpUseTls"
              class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800"
            />
            <span class="text-sm text-gray-700 dark:text-gray-300">Usar TLS</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="smtpUseSsl"
              [(ngModel)]="formSmtpUseSsl"
              class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800"
            />
            <span class="text-sm text-gray-700 dark:text-gray-300">Usar SSL</span>
          </label>
        </div>
      </div>
      }

      <!-- ─── API provider fields ─────────────────────────────────────────── -->
      @if (!isSmtp) {
      <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-4">
        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Configuración de API</p>

        <!-- API Key -->
        @if (showApiKey) {
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            API Key <span class="text-error-500">*</span>
          </label>
          <input
            type="password"
            name="apiKey"
            [(ngModel)]="formApiKey"
            placeholder="••••••••"
            autocomplete="new-password"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          @if (config) {
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Dejar vacío para mantener la clave actual</p>
          }
        </div>
        }

        <!-- Dominio API (Mailgun) -->
        @if (showApiDomain) {
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Dominio API <span class="text-error-500">*</span>
          </label>
          <input
            type="text"
            name="apiDomain"
            [(ngModel)]="formApiDomain"
            placeholder="mg.miempresa.com"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>
        }

        <!-- Base URL -->
        @if (showApiBaseUrl) {
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            URL base de la API
            @if (isApiBaseUrlRequired) {
            <span class="text-error-500">*</span>
            } @else {
            <span class="ml-1 text-xs text-gray-400 dark:text-gray-500">(opcional)</span>
            }
          </label>
          <input
            type="text"
            name="apiBaseUrl"
            [(ngModel)]="formApiBaseUrl"
            [required]="isApiBaseUrlRequired"
            placeholder="https://api.resend.com/emails"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>
        }
      </div>
      }

      <!-- Form action buttons -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()">
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving">
          {{ saving ? 'Guardando...' : (config ? 'Actualizar' : 'Guardar configuración') }}
        </app-button>
      </div>

    </form>
  </app-component-card>
  }

  <!-- ─── CONFIG CARD VIEW ───────────────────────────────────────────────── -->
  @if (!loading && !showForm && config) {
  <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

    <!-- Card header -->
    <div class="px-6 py-5 flex items-center justify-between gap-4 flex-wrap">
      <div>
        <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Configuración activa</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Proveedor de correo electrónico configurado para este negocio</p>
      </div>
      <!-- Action buttons -->
      <div class="flex items-center gap-2 flex-wrap">
        <ng-container *appHasPermission="'mail:edit'">
          <app-button variant="outline" size="sm" type="button" (btnClick)="abrirFormulario()">
            Editar
          </app-button>
        </ng-container>
        <app-button
          variant="outline"
          size="sm"
          type="button"
          [disabled]="testing"
          (btnClick)="enviarCorreoPrueba()">
          {{ testing ? 'Enviando...' : 'Enviar correo de prueba' }}
        </app-button>
        <ng-container *appHasPermission="'mail:edit'">
          <app-button variant="danger" size="sm" type="button" (btnClick)="desactivar()">
            Desactivar
          </app-button>
        </ng-container>
      </div>
    </div>

    <!-- Card body -->
    <div class="p-4 border-t border-gray-100 dark:border-gray-800 sm:p-6">
      <dl class="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2">

        <!-- Provider type -->
        <div class="col-span-1 sm:col-span-2 flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Proveedor</dt>
          <dd>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400">
              {{ providerLabel(config.providerType) }}
            </span>
          </dd>
        </div>

        <!-- Status -->
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Estado</dt>
          <dd>
            @if (config.isActive) {
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-success-50 text-success-700 dark:bg-success-500/10 dark:text-success-400">
              Activo
            </span>
            } @else {
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
              Inactivo
            </span>
            }
          </dd>
        </div>

        <!-- From email -->
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Correo remitente</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.fromEmail }}</dd>
        </div>

        <!-- From name -->
        @if (config.fromName) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Nombre remitente</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.fromName }}</dd>
        </div>
        }

        <!-- ─── SMTP details ─────────────────────────────────────────────── -->
        @if (isSmtpConfig) {
        @if (config.smtpHost) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Servidor SMTP</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.smtpHost }}</dd>
        </div>
        }
        @if (config.smtpPort) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Puerto</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.smtpPort }}</dd>
        </div>
        }
        @if (config.smtpUsername) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Usuario SMTP</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.smtpUsername }}</dd>
        </div>
        }
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">TLS</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.smtpUseTls ? 'Sí' : 'No' }}</dd>
        </div>
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">SSL</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.smtpUseSsl ? 'Sí' : 'No' }}</dd>
        </div>
        }

        <!-- ─── API provider details ─────────────────────────────────────── -->
        @if (!isSmtpConfig) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">API Key</dt>
          <dd class="text-sm text-gray-500 dark:text-gray-400 italic">Configurada (oculta)</dd>
        </div>
        @if (config.apiDomain) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Dominio API</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90">{{ config.apiDomain }}</dd>
        </div>
        }
        @if (config.apiBaseUrl) {
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">URL base</dt>
          <dd class="text-sm text-gray-800 dark:text-white/90 break-all">{{ config.apiBaseUrl }}</dd>
        </div>
        }
        }

        <!-- Timestamps -->
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Creado</dt>
          <dd class="text-sm text-gray-500 dark:text-gray-400">{{ formatDate(config.createdAt) }}</dd>
        </div>
        <div class="flex items-center gap-3">
          <dt class="text-sm font-medium text-gray-500 dark:text-gray-400 min-w-[120px]">Actualizado</dt>
          <dd class="text-sm text-gray-500 dark:text-gray-400">{{ formatDate(config.updatedAt) }}</dd>
        </div>

      </dl>
    </div>
  </div>
  }

  <!-- ─── EMPTY STATE ────────────────────────────────────────────────────── -->
  @if (!loading && !showForm && !config) {
  <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
        <svg class="w-8 h-8 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
        </svg>
      </div>
      <h3 class="mb-1 text-base font-medium text-gray-800 dark:text-white/90">
        Sin configuración de correo
      </h3>
      <p class="mb-6 text-sm text-gray-500 dark:text-gray-400 max-w-sm">
        Aún no hay un proveedor de correo configurado. Configure uno para poder enviar correos desde la plataforma.
      </p>
      <ng-container *appHasPermission="'mail:create'">
        <app-button variant="primary" type="button" (btnClick)="abrirFormulario()">
          Configurar proveedor de correo
        </app-button>
      </ng-container>
    </div>
  </div>
  }

</div>
